import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Paper, Pagination } from '@mui/material';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { API_RESPONSE, DIALOG_CONSTANT, NUMBER_CONSTANTS, TOASTER_CONFIGS } from '../../../Utilities/Constants/Constants';
import { useSelector } from 'react-redux';
import LockOpenTwoToneIcon from "@mui/icons-material/LockOpenTwoTone";
import HttpsIcon from "@mui/icons-material/Https";
import axios from 'axios';
import API_END_POINTS from '../../../Utilities/Constants/ApiEndpoints';
import { axiosInstance } from "../../../Services/Interceptor/Interceptor";
import ReasonDialog from '../../../Shared/ReasonDialog/ReasonDialog';
import { toast } from 'react-toastify';

const ChildUserList = () => {
    const navigate = useNavigate();
    const [childUsersList, setChildUsersList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPage, setTotalCount] = useState(0);
    const [rowPerPage, setRowPerPage] = useState(10);
    const [hasProducts, setHasProducts] = useState(API_RESPONSE.FALSE);
    const filtereddates: any = useSelector((state: any) => {
        return state.filterDatesReducer.filterdates
    })
    const [dialogOpenStatus, setDialogOpenStatus] = useState(false);
    const [blockId, setBlockId] = useState<any>("");
    const [unblockId, setUnBlockId] = useState<any>("");


useEffect(() => {
    const pathName = window.location?.pathname;
    const payload = {
      record_area: pathName.slice(1)
    }
    axiosInstance.post(`${API_END_POINTS?.RECORD_AREA}`, payload).then((response: any) => {
    }).catch(() => {
    })
  }, [])
  
    const dialogTitle = DIALOG_CONSTANT.BLOCK;
    useEffect(() => {
        ChildUserListApi();
    }, [page, rowPerPage])

    const childUserListPayload = () => {
        return {
            page: page,
            limit: rowPerPage,
            start_date: filtereddates?.filter_date?.start_date || "",
            end_date: filtereddates?.filter_date?.end_date || "",
        }
    }
    const checkEmpty = (data: any): boolean => {
        return data.length !== 0;
    };
    const ChildUserListApi = () => {
        axiosInstance.post(API_END_POINTS.CHILD_USER_LIST, childUserListPayload()).then((response: any) => {
            if (response?.status) {
                setChildUsersList(response?.data?.result?.data
                )
                const totalRecords = response?.data?.result?.total_count;
                setTotalCount(Math.ceil(totalRecords / rowPerPage))
                setHasProducts(checkEmpty(response.data.result.data));
            }

        })
    }

    const onRowChange = (event: any) => {
        setPage(NUMBER_CONSTANTS.ONE);
        setRowPerPage(parseInt(event.target.value));
    };

    const handleChangePage = (event: React.ChangeEvent<any>, newPage: number) => {
        setPage(newPage);
    };

    const onCloseDialog = () => {
        setDialogOpenStatus(false)
    }

    const onSubmitReason = (value: any) => {
        const payload = {
            id: blockId,
            block_type: "Child",
            reason: value?.reason,
        }

        axiosInstance.put(API_END_POINTS.BLOCK_USER_LIST, null, { params: payload }).then((respones: any) => {
            if (respones?.status) {
                toast.success(respones.data.message, TOASTER_CONFIGS);
                setDialogOpenStatus(false)
                ChildUserListApi();
                setBlockId("")
            }

        }).catch(() => {

        })
    }

    const handleUnblock = (id:any) => {
        const payload = {
            id: id,
            block_type: "Child",
            reason: ""
        }
        if (id) {
            axiosInstance.put(API_END_POINTS.BLOCK_USER_LIST, null, { params: payload }).then((response: any) => {
                if (response?.status) {
                    toast.success(response.data.message, TOASTER_CONFIGS);
                    ChildUserListApi();

                }
            }).catch(() => {

            })
        }

    }

    return (
        <div className="admin-list-wrapper">
            <div className="table-wrapper">
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>{t("S.NO")}</TableCell>
                                <TableCell>{t("First Name")}</TableCell>
                                <TableCell>{t("Last Name")}</TableCell>
                                <TableCell>{t("Email")}</TableCell>
                                <TableCell>{t("Actions")}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {hasProducts && childUsersList?.map((data: any, index: any) => {
                                return (
                                    <>
                                        <TableRow key={index + 1}>
                                            <TableCell>
                                                {page - 1 === 0
                                                    ? index + 1
                                                    : (page - 1) * rowPerPage + (index + 1)}
                                            </TableCell>
                                            <TableCell>
                                                {data.firstname}
                                            </TableCell>
                                            <TableCell>
                                                <span>{data.lastname}</span><br/>
                                            </TableCell>
                                            <TableCell>
                                                {data?.parent_email}
                                            </TableCell>
                                            <TableCell>
                                                <div className="action_wrap">
                                                  
                                                    {
                                                        data?.is_block
                                                            ? (
                                                                <div
                                                                    className="reject_btn_wrapper"
                                                                    onClick={() => {
                                                                        
                                                                        handleUnblock(data?.id)
                                                                    }}
                                                                >
                                                                    <div className="accept_btn_label">
                                                                        {t("Unblock")}
                                                                    </div>
                                                                    <div className="lock_icon_wrapper">
                                                                        <HttpsIcon className="lock_icon" />
                                                                    </div>
                                                                </div>) :
                                                            <div
                                                                className="accept_btn_wrapper"
                                                                onClick={() => {
                                                                    setDialogOpenStatus(true)
                                                                    setBlockId(data?.id)
                                                                }}
                                                            >
                                                                <div className="unlock_icon_wrapper">
                                                                    <LockOpenTwoToneIcon className="unlock_icon" />
                                                                </div>
                                                                <div className="accept_btn_label">
                                                                    {t("Block")}
                                                                </div>
                                                            </div>
                                                    }
                                                </div>

                                            </TableCell>

                                        </TableRow>
                                    </>
                                )
                            })}


                        </TableBody>

                    </Table>
                </TableContainer>
                {hasProducts && (
                    <div className="tablePagination">
                        <div className="row">
                            <div className="col-md-7">
                                <div className="pagination-wrap">
                                    <Pagination
                                        count={totalPage}
                                        page={page}
                                        onChange={handleChangePage}
                                    />
                                </div>
                            </div>
                            <div className="col-md-5">
                                <div className="rows-per-page">
                                    <p>{t("Rows per page")}:</p>
                                    <select
                                        className="rows-select"
                                        value={rowPerPage}
                                        onChange={onRowChange}
                                    >
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <ReasonDialog
                modalState={dialogOpenStatus}
                dialogStatus={onCloseDialog}
                submitReason={onSubmitReason}
                title={dialogTitle}
            />
        </div>
    )
}

export default ChildUserList
function ChildUserListApi() {
    throw new Error('Function not implemented.');
}

